import PropTypes from "prop-types"

export default function CountryCurrency({ currency, country }) {
  if (!currency || !country) {
    return null
  }
  return <div className="country-currency">{country} - {currency}</div>
}

CountryCurrency.propTypes = {
  currency: PropTypes.string,
  country: PropTypes.string,
}
